import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';

import { FirebaseApp } from '@angular/fire/app';
import { initializeApp } from 'firebase/app';
import { Auth, getAuth } from '@angular/fire/auth';
import { Firestore, getFirestore } from '@angular/fire/firestore';
import { getDataConnect, provideDataConnect } from '@angular/fire/data-connect';
import { Storage, getStorage } from '@angular/fire/storage';
import { Functions, getFunctions } from '@angular/fire/functions';
import { ConfigService } from './services/config.service';
import { connectFirebaseEmulators } from './firebase-emulators';

let firebaseApp: FirebaseApp;

export function initializeAppFactory(configService: ConfigService): () => Promise<void> {
  return () => configService.loadAppConfig().then(config => {
    if (!firebaseApp) { // Ensure it's only initialized once
      firebaseApp = initializeApp(config.firebase) as unknown as FirebaseApp;
      connectFirebaseEmulators(firebaseApp); // KAN-735: no-op except in the e2e-emulator build
      // Initialize secondary app for PhotoLavie
      if (config.firebasePhotoLavie) {
        initializeApp(config.firebasePhotoLavie, 'photolavie');
      }
    }
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideHttpClient(withFetch()),
    // KAN-147: Angular Material snackbars (and other animated Material parts) need an animations provider; lazy-loaded
    provideAnimationsAsync(),
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [ConfigService],
      multi: true
    },
    { provide: FirebaseApp, useFactory: () => firebaseApp },
    { provide: Auth, useFactory: () => getAuth(firebaseApp) },
    { provide: Firestore, useFactory: () => getFirestore(firebaseApp) },
    { provide: Storage, useFactory: () => getStorage(firebaseApp) },
    { provide: Functions, useFactory: () => getFunctions(firebaseApp) },
    provideDataConnect(() => getDataConnect({connector: "example",location: "us-east4",service: "erp-system-venture-2020"})), 
  ]
};
